import React from 'react';

const ReviewDetailModal = ({ isOpen, onClose, review }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-4/5 max-w-3xl shadow-lg max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded-t-lg">
                    <h2 className="text-xl font-bold">Review Details</h2>
                    <button
                        onClick={onClose}
                        className="text-red-600 hover:text-gray-900 text-2xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Content */}
                <div className="p-6">
                    {/* Review Title Section */}
                    <div className="flex mb-6 gap-8">
                        <div>
                            <h3 className="text-2xl font-bold">
                                {review.name}
                            </h3>
                        </div>
                    </div>

                    {/* User Details Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">User Details</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>User Title: </strong> {review.title}</div>
                            <div><strong>User Type: </strong> {review.user_type === "organization" ? "Organization" : "Artist"}</div>
                            <div><strong>User Id: </strong> {review.user_id || "NA"}</div>
                            <div><strong>User Country: </strong> {review.country || "NA"}</div>
                        </div>
                    </div>

                    {/* Review Details Section */}
                    <div className="mt-4">
                        <h4 className="text-xl font-semibold mb-2">Review Details</h4>
                        <div className="grid grid-cols-2 gap-4">
                        <div><strong>Visibility: </strong> {review.visibility ? "True" : "False"}</div>
                        <div><strong>Ratings: </strong> {review.ratings}</div>
                        </div>
                    </div>

                    {/* Description Section */}
                    <div className="mt-6">
                        <div className="relative flex items-center pt-5">
                            <div className="flex-grow border-t border-gray-400"></div>
                            <span className="flex-shrink mx-4 text-gray-400">Review</span>
                            <div className="flex-grow border-t border-gray-400"></div>
                        </div>
                        <div className="mt-4">
                            <p>{review.review}</p>
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="mt-6 flex justify-end">
                        <button onClick={onClose} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewDetailModal;